export const FEATURE_FLAG_REGIME_AUDITING = "regime-auditing"
